import React from 'react'
import { jumpToUser } from 'src/helper/webviewFun'
import Swiper from 'swiper'
import { isVoca } from 'src/helper/tool'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
    this.swiperChildRef = React.createRef()
  }

  state = {
    inWeekIndex: 0,
    weekItemList: [],
    myRank: {},
    isShowMyRank: false,
    rangTopImgArr: [
      '/img/activity/newWeeklyStar/ranking_one_icon.png',
      '/img/activity/newWeeklyStar/ranking_two_icon.png',
      '/img/activity/newWeeklyStar/ranking_three_icon.png'
    ],
    defaultLogoImg: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png'
  }

  componentDidMount() {
    const { lang } = this.props
    this.setState({
      weekItemList: [lang.this_week, lang.last_week]
    })
    if (!this.swiperInstance) {
      this.initSwiper()
    }
  }

  async componentDidUpdate(prevProps) {
    const { language, giftList, thisMyRank, selecCardItem, lang } = this.props

    if (language !== prevProps.language) {
      const weekItemList = [lang.this_week, lang.last_week]
      this.setState({
        weekItemList: language === 'ar' ? weekItemList.reverse() : weekItemList,
        inWeekIndex: language === 'ar' ? 1 : 0
      })
    }

    if ((JSON.stringify(giftList) !== JSON.stringify(prevProps.giftList))) {
      // if (!this.swiperInstance) {
      //   this.initSwiper()
      // }

      this.setState({
        myRank: thisMyRank,
        isShowMyRank: selecCardItem === 0 || (language === 'ar' && selecCardItem === 2)
      })
    }
  }

  handleSetLastThis = async (e) => {
    console.log('handleSetLastThis', e)
    this.swiperInstance.slideTo(e)
    this.updateMyRank(e)
    this.setState({ inWeekIndex: e })
  }

  topJt(e, type) {
    const { thisTopList, lostTopList } = this.props
    const uid = type === 'this' ? thisTopList[e].uid : lostTopList[e].uid
    jumpToUser(uid)
  }

  getTopkey(e, keys, type) {
    const { thisTopList, lostTopList } = this.props
    if (type === 'this' && thisTopList && thisTopList.length > 0) {
      const keyVlaue = thisTopList[e][keys]
      return keyVlaue
    }

    if (type === 'lost' && lostTopList && lostTopList.length > 0) {
      const keyVlaue = lostTopList[e][keys]
      return keyVlaue
    }

    return ''
  }

  getMyRandkIndex(e) {
    let str = ''
    if (e.rankIdx === 0 || !e.rankIdx) {
      str = '20+'
    } else if (e.rankIdx >= 20) {
      str = `${20}+`
    } else if (e.rankIdx <= 20) {
      str = e.rankIdx
    }
    return str
  }

  score(e) {
    e = e * 1 || 0
    if (e > 1000000) {
      e = (parseInt(e / 100000) / 10).toFixed(1) + 'M'
    } else if (e >= 1000) {
      e = (parseInt(e / 100) / 10).toFixed(1) + 'K'
    }

    return e || `- -`
  }

  initSwiper = () => {
    const { language } = this.props
    this.swiperInstance = new Swiper(this.swiperChildRef.current, {
      autoplay: false,
      slidesPerView: 1,
      initialSlide: language === 'ar' ? 1 : 0
      // autoHeight: true
    })

    this.swiperInstance.on('slideChange', (slide) => {
      const { activeIndex } = slide
      this.setState({ inWeekIndex: activeIndex })
      this.updateMyRank(activeIndex)
      if (language === 'ar') {
        this.props.onUpdateMyRank(activeIndex === 1 ? 'this' : 'lost')
      } else {
        this.props.onUpdateMyRank(activeIndex === 0 ? 'this' : 'lost')
      }
    })
  }

  updateMyRank = (index) => {
    const { thisMyRank, lostMyRank, language } = this.props

    if (language === 'ar') {
      this.setState({
        myRank: index === 1 ? thisMyRank : lostMyRank
      })
    } else {
      this.setState({
        myRank: index === 0 ? thisMyRank : lostMyRank
      })
    }
  }

  // 禁止滚动
  onNoSwiping = (value) => {
    this.swiperInstance.allowTouchMove = value
    this.props.onNoSwiping(value)
  };

  getGiftName = (item) => {
    const { language } = this.props

    if (language === 'tr') {
      return item.tr || item.name
    }

    if (language === 'ar') {
      return item.ar || item.name
    }

    return item.name
  }

  // 本周
  renderThisSwiper = () => {
    const {
      giftList,
      thisRankingList
    } = this.props
    const { rangTopImgArr, defaultLogoImg } = this.state

    return (
      <div>
        <div className="show-ranking-info">
          <div className="week-gift-root">
            <div
              className="itemsgirr"
              onTouchStart={() => this.onNoSwiping(false)}
              onTouchEnd={() => this.onNoSwiping(true)}
            >
              <div className="gift-item-root">
                {
                  giftList.length > 0 &&
                    giftList.map((item, index) => (
                      <div className="gift-item" key={index} >
                        <div className="item-img-root">
                          <img className="simg" src={item.image}></img>
                        </div>
                        <div className="item-name">{this.getGiftName(item)}</div>
                        <div className="item-pic">
                          <img className="gold-icon" src="/img/activity/newWeeklyStar/gold_icon_img.png"></img>
                          <div className="pic-num">{item.gold}</div>
                        </div>
                      </div>
                    ))
                }
              </div>
            </div>

            <div className="ranking-height">
              <div className="show-top-img">
                <div className="top-one">
                  <img className="top-one-head" src="/img/activity/newWeeklyStar/top_one_head.png"></img>
                  <img
                    className="top-one-atv"
                    onClick={() => this.topJt(0, 'this')}
                    src={this.getTopkey(0, 'avatarurl', 'this') || defaultLogoImg}
                  ></img>
                </div>
                <img className="top-one-starlight" src="/img/activity/newWeeklyStar/top_one_starlight.png"></img>
                <div className="podium-hetip"></div>
                <div className="top-two">
                  <img className="top-two-head" src="/img/activity/newWeeklyStar/top_twoorthree_head.png"></img>
                  <img
                    className="top-two-atv"
                    onClick={() => this.topJt(1, 'this')}
                    src={this.getTopkey(1, 'avatarurl', 'this') || defaultLogoImg}
                  ></img>
                </div>
                <div className="top-three">
                  <img className="top-two-head" src="/img/activity/newWeeklyStar/top_twoorthree_head.png"></img>
                  <img
                    className="top-two-atv"
                    onClick={() => this.topJt(2, this)}
                    src={this.getTopkey(2, 'avatarurl', 'this') || defaultLogoImg}
                  ></img>
                </div>
              </div>
              <div className="top-name-root">
                <div className="top-one-name">{this.getTopkey(1, 'nickname', 'this')}</div>
                <div className="top-two-name">{this.getTopkey(0, 'nickname', 'this')}</div>
                <div className="top-three-name">{this.getTopkey(2, 'nickname', 'this')}</div>
              </div>
            </div>
            <div className="ranking-list-weekstar">
              {
                thisRankingList &&
                thisRankingList.length > 0 &&
                thisRankingList.map((item, index) => (
                  <div className="inthe-item" key={index}>
                    <div className="inthe-item-left">
                      {index < 3 && <img className="user-ranking-num" src={rangTopImgArr[index]}></img>}
                      {index >= 3 && <div className="user-ranking-num">{item.rankIdx}</div>}
                      <img
                        className="item-user-avt"
                        onClick={() => jumpToUser(item.uid)}
                        src={item.avatarurl}
                      ></img>
                      <div className="item-user-name">{item.nickname}</div>
                    </div>
                    {
                      <div className="inthe-item-right">
                        <img className="gold-icon" src="/img/activity/newWeeklyStar/gold_icon_img.png"></img>
                        <div className="gold-num">{this.score(item.score)}</div>
                      </div>
                    }
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    )
  }

  // 上周
  renderLostSwiper = () => {
    const {
      giftLastList,
      lostRankingList
    } = this.props

    const { rangTopImgArr, defaultLogoImg } = this.state

    return (
      <div>
        <div className="show-ranking-info">
          <div className="week-gift-root">
            <div
              className="itemsgirr"
              onTouchStart={() => this.onNoSwiping(false)}
              onTouchEnd={() => this.onNoSwiping(true)}
            >
              <div className="gift-item-root">
                {giftLastList.length > 0 &&
                  giftLastList.map((item, index) => (
                    <div className="gift-item" key={index} >
                      <div className="item-img-root">
                        <img className="simg" src={item.image}></img>
                      </div>
                      <div className="item-name">{this.getGiftName(item)}</div>
                      <div className="item-pic">
                        <img className="gold-icon" src="/img/activity/newWeeklyStar/gold_icon_img.png"></img>
                        <div className="pic-num">{item.gold}</div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            <div className="ranking-height">
              <div className="show-top-img">
                <div className="top-one">
                  <img className="top-one-head" src="/img/activity/newWeeklyStar/top_one_head.png"></img>
                  <img
                    className="top-one-atv"
                    onClick={() => this.topJt(0, 'lost')}
                    src={this.getTopkey(0, 'avatarurl', 'lost') || defaultLogoImg}
                  ></img>
                </div>
                <img className="top-one-starlight" src="/img/activity/newWeeklyStar/top_one_starlight.png"></img>
                <div className="podium-hetip"></div>
                <div className="top-two">
                  <img className="top-two-head" src="/img/activity/newWeeklyStar/top_twoorthree_head.png"></img>
                  <img
                    className="top-two-atv"
                    onClick={() => this.topJt(1, 'lost')}
                    src={this.getTopkey(1, 'avatarurl', 'lost') || defaultLogoImg}
                  ></img>
                </div>
                <div className="top-three">
                  <img className="top-two-head" src="/img/activity/newWeeklyStar/top_twoorthree_head.png"></img>
                  <img
                    className="top-two-atv"
                    onClick={() => this.topJt(2, 'lost')}
                    src={this.getTopkey(2, 'avatarurl', 'lost') || defaultLogoImg}
                  ></img>
                </div>
              </div>
              <div className="top-name-root">
                <div className="top-one-name">{this.getTopkey(1, 'nickname', 'lost')}</div>
                <div className="top-two-name">{this.getTopkey(0, 'nickname', 'lost')}</div>
                <div className="top-three-name">{this.getTopkey(2, 'nickname', 'lost')}</div>
              </div>
            </div>
            <div className="ranking-list-weekstar">
              {
                lostRankingList &&
                lostRankingList.length > 0 &&
                lostRankingList.map((item, index) => (
                  <div className="inthe-item" key={index}>
                    <div className="inthe-item-left">
                      {index < 3 && <img className="user-ranking-num" src={rangTopImgArr[index]}></img>}
                      {index >= 3 && <div className="user-ranking-num">{item.rankIdx}</div>}
                      <img
                        className="item-user-avt"
                        onClick={() => jumpToUser(item.uid)}
                        src={item.avatarurl}
                      ></img>
                      <div className="item-user-name">{item.nickname}</div>
                    </div>
                    {
                      <div className="inthe-item-right">
                        <img className="gold-icon" src="/img/activity/newWeeklyStar/gold_icon_img.png"></img>
                        <div className="gold-num">{this.score(item.score)}</div>
                      </div>
                    }
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    let {
      language,
      showTabNo
    } = this.props

    const { inWeekIndex, weekItemList } = this.state

    return (
      <div className="rangking-root">
        {showTabNo && <div className="week-select">
          {
            weekItemList.length > 0 &&
              weekItemList.map((item, index) => (
                <div
                  key={item}
                  className={`${inWeekIndex === index ? 'intheweek' : 'notheweek'}`}
                  onClick={() => this.handleSetLastThis(index)}
                >
                  {item}
                </div>
              ))
          }
        </div>}
        <div
          className='swiper-container'
          ref={this.swiperChildRef}
          style={{ direction: language === 'ar' ? 'ltr' : 'inherit' }}
        >
          <div className="swiper-wrapper">
            {
              language !== 'ar' &&
              [this.renderThisSwiper(), this.renderLostSwiper()].map((item, index) => (
                <div className="swiper-slide" key={index}>
                  {item}
                </div>
              ))
            }
            {
              language === 'ar' &&
              [this.renderThisSwiper(), this.renderLostSwiper()].reverse().map((item, index) => (
                <div className="swiper-slide" key={index}>
                  {item}
                </div>
              ))
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/newWeeklyStar/tab-wealth.js